import request from '@/utils/request'

const goodsCar = {
  name: 'goodsCar',
  state: {
    isGoodsCarDetailLoading: false,
    goodsCarDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_GOODSCAR_DETAIL_LOADING: (state, data) => {
      state.isGoodsCarDetailLoading = data
    },
    SET_MODULES_GOODSCAR_DETAIL_DATA: (state, data) => {
      state.goodsCarDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryGoodsCarDetailData({ commit }, id) {
      commit('SET_IS_MODULES_GOODSCAR_DETAIL_LOADING', true)
      commit('SET_MODULES_GOODSCAR_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/goodsCar/goodsCarDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_GOODSCAR_DETAIL_LOADING', false)
          commit('SET_MODULES_GOODSCAR_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_GOODSCAR_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetGoodsCarDetailData({ commit }) {
      commit('SET_MODULES_GOODSCAR_DETAIL_DATA', {})
    }
  }
}

export default goodsCar
